import React from 'react';
import PropTypes from 'prop-types';

export default function ModalActions({ children }) {
    return (
        <div data-component="ModalActions" className="sarsa-modal-actions">
            {children}
        </div>
    );
}

ModalActions.propTypes = {
    children: PropTypes.node
}